import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  subMessage?: string;
  onConfirm: () => void;
  onCancel: () => void;
  cancelName?: string;
  confirmName?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, title, message, subMessage, onConfirm, onCancel, cancelName, confirmName }) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirmation-dialog-description">
          {message}
        </DialogContentText>
        <DialogContentText id="confirmation-dialog-description">
          {subMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {cancelName || 'Cancel'}
        </Button>
        <Button onClick={onConfirm} color="secondary" autoFocus>
          {confirmName || 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;